<template>
  <textarea v-model="encoded"></textarea>
  <div class="buttons-container">
    <button @click="decode">Decode</button>
    <label>
      <input type="radio" value="teltonika-parser-extended" v-model="selectedParser" @change="decode()"/>
      teltonika-parser-extended
    </label>
    <label>
      <input type="radio" value="teltonika-parser-ex" v-model="selectedParser" @change="decode()"/>
      teltonika-parser-ex
    </label>
    <label>
      <input type="radio" value="teltonika-parser-fix" v-model="selectedParser" @change="decode()"/>
      teltonika-parser-fix
    </label>
    <label>
      <input type="radio" value="complete-teltonika-parser" v-model="selectedParser" @change="decode()"/>
      complete-teltonika-parser
    </label>
    <label>
      <input type="radio" value="teltonika-decoder" v-model="selectedParser" @change="decode()"/>
      teltonika-decoder
    </label>
    <label>
      <input type="radio" value="php: TeltonikaFmParser" v-model="selectedParser" @change="decode()"/>
      php: TeltonikaFmParser
    </label>
  </div>
  <h3>Result:</h3>
  <pre class="teltonika-decoded">{{ decoded }}</pre>
</template>

<script>
import TeltonikaParserExtended from 'teltonika-parser-extended';
import TeltonikaParserEx from 'teltonika-parser-ex';
import TeltonikaParserFix from 'teltonika-parser-fix';
import {ProtocolParser as CompleteTeltonikaParser} from "complete-teltonika-parser";
import {decode as TeltonikaDecoder} from "teltonika-decoder";
import {endpoints} from "@/assets/js/vue/vuex/endpoints";
import requestHelper from "@/assets/js/vue/vuex/request-helper";

export default {
  name: 'TeltonikaDecoder',
  data() {
    return {
      encoded: '',
      decoded: '',
      selectedParser: "teltonika-parser-extended"
    };
  },
  methods: {
    decode() {
      if (!this.encoded) {
        return;
      }

      const binary = Buffer.from(this.encoded, 'hex');
      console.log(binary);

      switch (this.selectedParser) {
        case "teltonika-parser-extended": {
          try {
            const parser = new TeltonikaParserExtended(binary);
            this.decoded = parser.getAvl();
          }
          catch (e) {
            this.decoded = e;
          }
          break;
        }

        case "teltonika-parser-ex": {
          try {
            const parser = new TeltonikaParserEx(binary);
            this.decoded = parser.getAvl();
          }
          catch (e) {
            this.decoded = e;
          }
          break;
        }

        case "teltonika-parser-fix": {
          try {
            const parser = new TeltonikaParserFix(binary);
            this.decoded = parser.getAvl();
          }
          catch (e) {
            this.decoded = e;
          }
          break;
        }

        case "complete-teltonika-parser": {
          try {
            const parsed = new CompleteTeltonikaParser(this.encoded);
            this.decoded = parsed.Content;
          }
          catch (e) {
            this.decoded = e;
          }

          break;
        }

        case "teltonika-decoder": {
          try {
            const result = TeltonikaDecoder(binary)
            this.decoded = result.data;
          }
          catch (e) {
            this.decoded = e;
          }

          break;
        }

        case "php: TeltonikaFmParser": {
          try {

            const endpoint = process.env.VUE_APP_BACKEND_ENDPOINT_URL.replace('/v1', '') + '/' + endpoints.TELTONIKA_DECODER;
            requestHelper.apiGet(endpoint, window.localStorage.getItem('_token'), {data: this.encoded})
                .then(response => {
                  if (!response.ok) {
                    this.decoded = response.statusText;
                  }

                  response.json().then(res => this.decoded = res);
                })
                .catch(error => {
                  this.decoded = error;
                });
          }
          catch (e) {
            this.decoded = e;
          }

          break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.buttons-container {
  display: block;
}
textarea {
  width: calc(100% - 10px);
  height: 300px;
}
</style>
